import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Mail } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const btn = "inline-flex items-center gap-2 rounded-full px-4 py-2.5 text-sm font-semibold disabled:opacity-50";

export const ReplyDialog = ({ p, statuses, headers, onClose, onSaved }) => {
  const [text, setText] = useState("");
  const [res, setRes] = useState(null);
  const [status, setStatus] = useState("");
  const analyze = async () => {
    try {
      const { data } = await axios.post(`${API}/admin/prospects/${p.id}/reply`, { text }, { headers: headers() });
      setRes(data); setStatus(data.suggested_status);
    } catch (e) { toast.error(e.response?.data?.detail || "Analyse impossible"); }
  };
  const save = async () => {
    try {
      await axios.put(`${API}/admin/prospects/${p.id}`, { status, next_action: status === "intéressé" ? "Répondre et suivre la commande (WhatsApp / e-mail)" : status === "ne plus contacter" ? "Aucune (désinscrit)" : "Aucune" }, { headers: headers() });
      toast.success("Suivi mis à jour"); onSaved();
    } catch { toast.error("Erreur"); }
  };
  const wa = p.phone ? `https://wa.me/${p.phone.replace(/\D/g, "").replace(/^00/, "").replace(/^0/, "33")}` : null;
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl" data-testid="prospect-reply-dialog">
        <DialogHeader><DialogTitle>Réponse reçue — {p.name}</DialogTitle></DialogHeader>
        {!res ? (
          <>
            <textarea value={text} onChange={(e) => setText(e.target.value)} rows={6} placeholder="Collez ici la réponse du prospect (e-mail ou WhatsApp)"
              data-testid="prospect-reply-input" className="w-full rounded-lg border border-[var(--oz-border)] p-3 text-sm" />
            <button onClick={analyze} disabled={!text.trim()} data-testid="prospect-reply-analyze" className={`${btn} bg-[var(--oz-dark)] text-white self-start`}>Analyser la réponse</button>
          </>
        ) : (
          <>
            <label className="text-sm font-semibold">Statut proposé</label>
            <select value={status} onChange={(e) => setStatus(e.target.value)} data-testid="prospect-reply-status" className="rounded-full border border-[var(--oz-border)] px-3 py-2 text-sm self-start">
              {statuses.map((s) => <option key={s}>{s}</option>)}
            </select>
            <p className="text-sm font-semibold mt-2">Réponse toute prête</p>
            <pre data-testid="prospect-reply-body" className="whitespace-pre-wrap text-sm font-sans max-h-[35vh] overflow-y-auto rounded-lg bg-[var(--oz-bg)] p-3">{res.body}</pre>
            <div className="flex flex-wrap gap-2">
              {res.to && <a href={`mailto:${res.to}?subject=${encodeURIComponent(res.subject)}&body=${encodeURIComponent(res.body)}`} data-testid="prospect-reply-mail" className={`${btn} border border-[var(--oz-border)]`}><Mail className="w-4 h-4" /> Répondre par e-mail</a>}
              {wa && <a href={`${wa}?text=${encodeURIComponent(res.body)}`} target="_blank" rel="noreferrer" data-testid="prospect-reply-whatsapp" className={`${btn} bg-[#25D366] text-[#0B2E13]`}>Répondre sur WhatsApp</a>}
              <button onClick={save} data-testid="prospect-reply-save" className={`${btn} bg-[var(--oz-gold)] text-[var(--oz-dark)]`}>Enregistrer le statut</button>
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};
